var _path, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInfoGrey = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_676_2",
    "data-name": "Component 676 \\u2013 2",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8127",
    "data-name": "Path 8127",
    d: "M253.926,245.645a8,8,0,1,0,8,8A8.009,8.009,0,0,0,253.926,245.645Zm0,14.815a6.815,6.815,0,1,1,6.815-6.815A6.822,6.822,0,0,1,253.926,260.46Z",
    transform: "translate(-245.926 -245.645)",
    fill: "#95A1B2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2932",
    "data-name": "Group 2932",
    transform: "translate(6.5 3.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2934",
    "data-name": "Group 2934",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 1.11,
    cy: 1.11,
    r: 1.11,
    transform: "translate(0.407)",
    fill: "#95A1B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M200.049,201.418v.859h-3.033v-.859h.553v-3.637h-.553v-.859h2.48v4.5Z",
    transform: "translate(-197.016 -193.749)",
    fill: "#95A1B2"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoGrey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info-grey.6f2912e3.svg";
export { ForwardRef as ReactComponent };